import MD5 from 'crypto-js/md5';

/**
 * Hashes (MD5) provided string
 * @param stringToBeHashed input string
 * @returns md5 hashed string
 */
export const hashString = (stringToBeHashed: string): string =>
	typeof stringToBeHashed == 'string' ? MD5(stringToBeHashed).toString() : undefined;
